import { api } from '../../services/api';
import { progressSaves } from './progressModel';

/**
 * P-10e (D-82) — save the status (not 🟢) and the bar of a task changed in a
 * timer window. Returns whether 🟢 "הושלם" was chosen: the caller then runs
 * the regular close (`requestCloseAfterTimer`). The status goes first, so the
 * bar is saved on top of it.
 */
export async function saveTaskProgress(
  ticketId: string,
  before: { status: string | null | undefined; progress: number },
  after: { status: string | null | undefined; progress: number }
): Promise<{ complete: boolean }> {
  const s = progressSaves(before, after);
  if (s.status) await api.updateTicketStatus(ticketId, s.status);
  if (s.progress !== null) await api.updateTicket(ticketId, { progress_percent: s.progress });
  return { complete: s.complete };
}
